module.exports = __webpack_public_path__ + "static/media/IconTemplates_-91.90cf4308.svg";